import { languages } from "../statemanagement/stateManagement";
import i18n from "../utilities/i18n";
import Button from "@material-ui/core/Button";

const switchLanguage = (lng) => {
  localStorage.removeItem("preferedLanguage");
  i18n.changeLanguage(lng);
  localStorage.setItem("preferedLanguage", lng);
}

export const LanguageSelection = () => {
  return (
    <>
      {languages.value.map((lng) => (
        <Button key={'btn' + lng} onClick={() => switchLanguage(lng)}>
          <img
            className="languageButton"
            alt={lng}
            title={lng}
            key={'img' + lng}
            src={`/flag/${lng}.svg`}
          />
        </Button>
      ))}
    </>
  );
};
